<template>
    <div id="module-swiper" class="swiper swiper-h" :style="{ height: `calc(100% - ${config.headerHeight}px)` }">
        <div class="swiper-wrapper">
            <template v-for="(item, index) in swipeList">
                <div v-if="item.swipeType === 'result'" class="swiper-slide" :key="item.uid">
                    <ResultReport mode="Mobile" />
                </div>
                <div v-if="item.swipeType === 'module'" class="swiper-slide module-view" :key="item.uid">
                    <div class="container">
                        <div class="title">
                            <span>{{ item.unit }}</span> {{ item.title }}
                        </div>
                        <TextTemplate class="subtitle" v-if="item.subtitle" :text="item.subtitle" />
                    </div>
                    <div class="guide">
                        <img src="https://res.peki.vip/20220908/fe5c541db2d14d68b949dbd9b9219ade1.png" />
                    </div>
                </div>
                <div class="swiper-slide" v-else-if="item.swipeType === 'question'" :key="`${item.uid}-question`">
                    <template v-if="currentIndex - index < 3 && index - currentIndex < 3">
                        <Choice :question="item.question" v-if="['SINGLE_CHOICE', 'JUDGMENT'].includes(item.type)" />
                        <MuletpleChoice :question="item.question" v-if="item.type === 'MULTIPLE_CHOICE'" />
                        <Blank :question="item.question" v-if="['DISORDER_BLANK', 'ORDER_BLANK'].includes(item.type)" />
                        <Writing :question="item.question" v-if="item.type === 'WRITING'" />
                    </template>
                    <Complex :question="item.question" v-if="complexTypes.includes(item.type)" />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import TextTemplate from '../TextTemplate.vue'
import ResultReport from './ResultReport.vue'
import Choice from './question/Choice.vue'
import MuletpleChoice from './question/MuletpleChoice.vue'
import Blank from './question/Blank.vue'
import Complex from './question/Complex.vue'
import Writing from './question/Writing.vue'
import audioManager from '@/utils/audioManager'

export default {
    components: { TextTemplate, ResultReport, Choice, MuletpleChoice, Blank, Writing, Complex },
    computed: {
        config() {
            return this.$store.state.paperResult.config
        },
        complexTypes() {
            return this.$store.state.paperResult.complexTypes
        },
        jumpQuestion() {
            return this.$store.state.paperResult.jumpQuestion
        },
        swipeList() {
            const moduleList = this.$store.state.paperResult.moduleList
            const list = [{ swipeType: 'result', uid: `result` }]
            moduleList.forEach((mItem) => {
                list.push({
                    swipeType: 'module',
                    uid: `module${mItem.id}`,
                    title: mItem.title,
                    subtitle: mItem.subtitle,
                    unit: mItem.unit,
                })
                mItem.questions.forEach((item) => {
                    list.push({
                        swipeType: 'question',
                        uid: `module${item.id}`,
                        id: item.id,
                        type: item.type,
                        indexNo: item.indexNo,
                        question: item,
                        hasChildren: item.childQuestions && item.childQuestions.length !== 0,
                    })
                })
            })
            return list
        },
    },
    data() {
        return {
            currentIndex: 0,
        }
    },
    watch: {
        jumpQuestion: function () {
            this.swipeList.forEach((item, index) => {
                if (this.jumpQuestion.questionId === item.id) {
                    this.moduleSwipe.slideTo(index, 1, false)
                }
            })
        },
    },
    mounted() {
        this.moduleSwipe = new window.Swiper('#module-swiper')
        this.moduleSwipe.on('slideChange', () => {
            this.onSwipeChange()
        })
    },
    methods: {
        onSwipeChange() {
            this.currentIndex = this.moduleSwipe.activeIndex
            const swipe = this.swipeList[this.moduleSwipe.activeIndex]
            let question = null

            if (swipe.swipeType === 'question') {
                question = { id: swipe.id, indexNo: swipe.indexNo }
            }
            this.$store.dispatch('paperResult/setCurrentQuestion', question)
            if (!question || !question.hasChildren) {
                this.$store.dispatch('paperResult/setCurrentSubQuestion', null)
            }

            audioManager.stop()
        },
    },
}
</script>
<style lang="scss" scoped>
#module-swiper {
    width: 100%;
}
.module-view {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    .container {
        flex-grow: 1;
        .title {
            padding: 60px 20px 12px;
            text-align: center;
            font-size: 18px;
            font-weight: 700;
        }
        .subtitle {
            padding: 0 40px;
            overflow-y: auto;
            font-size: 14px;
            color: #999;
            line-height: 1.4em;
        }
    }
    .guide {
        display: flex;
        justify-content: flex-end;
        margin: 70px 12px 32px 0;
        img {
            width: 100px;
            height: 100px;
        }
    }
}
</style>
